<template>
  <img v-if="person && person.image" class="person-avatar" :class="sizeClass" :src="person.image" alt=""
       loading="lazy" decoding="async"
  />
  <span v-else-if="fallback === 'silhouette'" class="person-avatar tw-block tw-overflow-hidden tw-bg-primary-low" :class="sizeClass">
    <svg viewBox="0 0 200 200" aria-hidden="true" class="tw-block tw-w-full tw-h-full tw-fill-white">
      <ellipse cx="102" cy="101" rx="42" ry="46"/>
      <path d="M30 200c0-32 30-48 72-48s72 16 72 48z"/>
    </svg>
  </span>
  <span v-else class="person-avatar person-avatar--initials" :class="sizeClass">{{ initials }}</span>
</template>

<script>
// Anyone with { image, firstName, lastName }: athletes, dietitians, mobile users.
export default {
  props: {
    person: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['xs', 'sm', 'md', 'lg', 'xl'].includes(v)
    },
    // What to show without an image: 'initials' or a quiet 'silhouette'.
    fallback: {
      type: String,
      default: 'initials',
      validator: v => ['initials', 'silhouette'].includes(v)
    }
  },
  computed: {
    initials() {
      if (!this.person) return '?';
      const f = (this.person.firstName || '').charAt(0).toUpperCase();
      const l = (this.person.lastName || '').charAt(0).toUpperCase();
      return f + l || '?';
    },
    sizeClass() {
      return `person-avatar--${this.size}`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@src/design/_custom_variables.scss';

.person-avatar {
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;

  &--initials {
    background: rgba($color_primary, 0.1);
    color: $color_primary;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &--xs {
    width: 22px;
    height: 22px;
    font-size: 0.55rem;
  }

  &--sm {
    width: 30px;
    height: 30px;
    font-size: 0.6rem;
  }

  &--md {
    width: 36px;
    height: 36px;
    font-size: 0.7rem;
  }

  &--lg {
    width: 56px;
    height: 56px;
    font-size: 1rem;
    font-weight: 700;
  }

  &--xl {
    width: 100px;
    height: 100px;
    font-size: 1.5rem;
    font-weight: 700;
  }
}
</style>
